import {
  defaultBackgroundSetting,
  defaultBorderSetting,
  defaultFontSetting,
  defaultPaddingSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultIconSetting,
  defaultComplexFontSetting,
  defaultSimpleFontSetting
} from "@/materials/navMenu/render/customSubMenus/setting/defaultSetting"
export const props = [
  {
    name: "mainAlign",
    desc: "对齐",
    type: "sliderSet",
    defaultValue: "center",
    extraConfig: {
      showToolTip: true,
      options: [
        {
          value: "flex-start",
          label: "左对齐",
          iconClass: "icon-portal-Align-left"
        },
        {
          value: "center",
          label: "居中对齐",
          iconClass: "icon-portal-Center-lr"
        },
        {
          value: "flex-end",
          label: "右对齐",
          iconClass: "icon-portal-Align-right"
        }
      ],
      titleStyle: {
        width: "52px"
      }
    }
  },
  {
    name: "mainBackground",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "mainBorder",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting,
      showEnableCheckbox: true
    }
  },
  {
    name: "showMainBorder",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "mainRadius",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "leftDis",
    desc: "左右间距",
    type: "numberSet",
    defaultValue: 0,
    unit: "px",
    extraConfig: {
      suffix: "px"
    }
  },
  {
    name: "topDis",
    desc: "上下间距",
    type: "numberSet",
    defaultValue: 0,
    unit: "px",
    extraConfig: {
      suffix: "px"
    }
  },
  {
    name: "mainOpacity",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "mainShadow",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "mainPadding",
    desc: "内边距",
    type: "paddingSet",
    defaultValue: defaultPaddingSetting
  },
]

export const menuSetting = [
  {
    type: "collapse",
    title: "排列",
    settings: ["mainAlign", "leftDis", "topDis"]
  },
  {
    type: "collapse",
    title: "背景",
    settings: ["mainBackground"]
  },
  {
    type: "collapse",
    title: "边框",
    initStatus: 'closed',
    settings: [
      {
        type: "basic",
        name: "mainBorder",
      },
      "mainRadius"
    ]
  },
  {
    type: "collapse",
    title: "边距",
    initStatus: 'closed',
    settings: ["mainPadding"]
  },
  {
    type: "collapse",
    title: "更多",
    initStatus: 'closed',
    settings: ["mainOpacity", "mainShadow"]
  }
]
